// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.viewWrapper {
  right: 16px;
  width: 146px;
  bottom: 6px;
  cursor: pointer;
  height: 146px;
  position: absolute;
  z-index: 10;
}
.viewWrapper .polygon {
  fill: white;
}
.viewWrapper .upperBtn {
  width: 82px;
  height: 26px;
  margin-left: 36px;
  display: block;
}
.viewWrapper .backBtn,
.viewWrapper .frontBtn,
.viewWrapper .lowerBtn,
.viewWrapper .homeBtn {
  width: 82px;
  margin-left: 36px;
  margin-top: 2px;
  display: block;
}
.viewWrapper .leftBtn,
.viewWrapper .rightBtn {
  width: 26px;
  height: 82px;
  margin-top: -110px;
  display: block;
}
.viewWrapper .rightBtn {
  float: left;
  margin-left: 8px;
}
.viewWrapper .leftBtn {
  float: right;
}
.viewWrapper .backBtn,
.viewWrapper .frontBtn,
.viewWrapper .homeBtn {
  height: 26px;
}
.viewWrapper .lowerBtn {
  height: 26px;
}
.viewWrapper .text {
  text-anchor: middle;
  fill: #000000;
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  line-height: 18px;
}
.viewWrapper .rotateRight {
  transform: rotate(270deg);
}
.viewWrapper .rotateLeft {
  transform: rotate(90deg);
}
.viewPopover .ant-popover-content {
  top: 30px;
  right: 20px;
}
.mobileWrap {
  position: absolute;
  top: 44px;
  left: 16px;
  z-index: 10;
}
.mobileWrap div {
  background-color: white;
  border-radius: 8px;
  height: 18px;
}
.mobileWrap span {
  font-weight: 400;
  color: black;
  font-size: 12px;
  display: inline-block;
}
.mobileWrap .navigator {
  width: 79px;
  display: flex;
  padding: 0 0 0 8px;
  flex-direction: row;
  align-items: center;
  font-size: 12px;
  line-height: 18px;
}
.mobileWrap .navigator span {
  position: relative;
  top: -1px;
  display: inline-block;
  margin-left: 4px;
  line-height: 18px;
}
.mobileWrap .direct {
  width: 51px;
  margin-top: 8px;
  text-align: center;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/View/Option/Components/View/index.less"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;AACF;AARA;EAUI,WAAA;AACJ;AAXA;EAcI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AAAJ;AAjBA;;;;EAqBI,WAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;AAEJ;AA1BA;;EA4BI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AAEJ;AAjCA;EAmCI,WAAA;EACA,gBAAA;AACJ;AArCA;EAwCI,YAAA;AAAJ;AAxCA;;;EA6CI,YAAA;AAAJ;AA7CA;EAiDI,YAAA;AADJ;AAhDA;EAqDI,mBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AAFJ;AAxDA;EA8DI,yBAAA;AAHJ;AA3DA;EAkEI,wBAAA;AAJJ;AAQA;EAEI,SAAA;EACA,WAAA;AAPJ;AAYA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;AAVF;AAMA;EAOI,uBAAA;EACA,kBAAA;EACA,YAAA;AAVJ;AACA;EAaI,gBAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;AAXJ;AALA;EAoBI,WAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AAZJ;AAdA;EA4BM,kBAAA;EACA,SAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;AAXN;AArBA;EAsCI,WAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;AAdJ","sourcesContent":[".viewWrapper {\n  right: 16px;\n  width: 146px;\n  bottom: 6px;\n  cursor: pointer;\n  height: 146px;\n  position: absolute;\n  z-index: 10;\n\n  .polygon {\n    fill: white;\n  }\n\n  .upperBtn {\n    width: 82px;\n    height: 26px;\n    margin-left: 36px;\n    display: block;\n  }\n\n  .backBtn, .frontBtn, .lowerBtn, .homeBtn {\n    width: 82px;\n    margin-left: 36px;\n    margin-top: 2px;\n    display: block;\n  }\n\n  .leftBtn, .rightBtn {\n    width: 26px;\n    height: 82px;\n    margin-top: -110px;\n    display: block;\n  }\n\n  .rightBtn {\n    float: left;\n    margin-left: 8px;\n  }\n\n  .leftBtn {\n    float: right;\n    //margin-right: 8px;\n  }\n\n  .backBtn, .frontBtn, .homeBtn {\n    height: 26px;\n  }\n\n  .lowerBtn {\n    height: 26px;\n  }\n\n  .text {\n    text-anchor: middle;\n    fill: rgb(0, 0, 0);\n    font-size: 16px;\n    font-weight: 400;\n    font-style: normal;\n    line-height: 18px;\n  }\n\n  .rotateRight {\n    transform: rotate(270deg);\n  }\n\n  .rotateLeft {\n    transform: rotate(90deg);\n  }\n}\n\n.viewPopover {\n  .ant-popover-content {\n    top: 30px;\n    right: 20px;\n  }\n}\n\n\n.mobileWrap {\n  position: absolute;\n  top: 44px;\n  left: 16px;\n  z-index: 10;\n\n  div {\n    background-color: white;\n    border-radius: 8px;\n    height: 18px;\n  }\n\n  span {\n    font-weight: 400;\n    color: black;\n    font-size: 12px;\n    display: inline-block;\n  }\n\n  .navigator {\n    width: 79px;\n    display: flex;\n    padding: 0 0 0 8px;\n    flex-direction: row;\n    align-items: center;\n    font-size: 12px;\n    line-height: 18px;\n    span{\n      position: relative;\n      top: -1px;\n      display: inline-block;\n      margin-left: 4px;\n      line-height: 18px;\n\n    }\n  }\n\n  .direct {\n    width: 51px;\n    margin-top: 8px;\n    text-align: center;\n    justify-content: center;\n  }\n}\n\n@primary-color: black;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
